const axios = require('axios/index');
const _ = require('lodash');

const profileQuery = function(slug, type, locale, recommendationId) {
    const recommendationQuery = !_.isNil(recommendationId)
        ? `, recommendationId: "${recommendationId}" `
        : '';
    return `query {
        profile(slug: "${slug}", pageType: ${type}, lang: "${locale}" ${recommendationQuery}) {
          id
          name
          meta {
            title
            description
            structuredData
            social {
              title
              description
              url
              type
              image
              siteName
              locale
            }
          }
          breadcrumbs {
            name
            url
          }
          color
          service
          category
          location#
      #    videos
          picture {
            cover {
              l
            }
            logo {
              l
            }
          }
          employeesRange
          handles {
            name
            url
          }
          url
          siteUrl
          hasAccessMultilingual
          hasAccessLangs
          about
          tag {
            activities
            specialties
          }
          hasAccessCollections
          collections {
            id
            endorsements {
              client
              org
            }
          }
          references {
            id
            state
            createdAt
            url
            sourceLang
            meta {
              title
              description
              social {
                title
                description
                url
                type
                image
                siteName
                locale
              }
            }
            video {
              id
              previewId
            }
            person {
              name
              picture {
                m
              }
              jobTitle
            }
            organization {
              name
              picture {
                m
              }
              about
              areas
            }
            testimony
            qualities {
              id
              label
            }
          }
          qualities {
            id
            label
            count
            url
            meta {
              title
              description
              social {
                title
                description
                url
                type
                image
                siteName
                locale
              }
            }
            references {
              id
              person {
                name
                picture {
                  m
                }
                jobTitle
              }
              organization {
                name
                picture {
                  m
                }
              }
            }
          }
          articles {
              excerpt
              picture
              publishedAt
              title
              url
          }
          faqs {
            question
            answer
          }
          companies {
            id
            name
            picture {
              m
            }
          }
        }
      }`;
};

const resetProvidersQuery = 'mutation {resetProviders {ids}}';

function pathsQuery(baseQuery) {
    return `query {
    ${baseQuery} {
      organizationSlug
      enabledLocales
      recommendationsPublicIds
      qualitiesPublicIds
      hasAccessWidgetGroups
    }
  }`;
}

async function perform(query, token) {
    return await axios.post(process.env.PROFILE_API_URL + '?token=' + token, {
        query: query
    });
}

module.exports = { profileQuery, resetProvidersQuery, pathsQuery, perform };
